module.exports = __webpack_public_path__ + "static/42ce93b57eecec7597567939ec4a36fdbb5a66622e976a1a552dce33fb9f0780-a699c6be0725fd9cc1db05d62e62d925.jpeg";